var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.2L2.5 6.70001C2.40847 6.60737 2.29947 6.53382 2.17931 6.48362C2.05915 6.43342 1.93022 6.40757 1.8 6.40757C1.66977 6.40757 1.54084 6.43342 1.42068 6.48362C1.30052 6.53382 1.19152 6.60737 1.1 6.70001C1.00736 6.79153 0.933804 6.90053 0.883605 7.02069C0.833405 7.14085 0.807556 7.26978 0.807556 7.40001C0.807556 7.53023 0.833405 7.65916 0.883605 7.77932C0.933804 7.89948 1.00736 8.00848 1.1 8.10001L5.29 12.29C5.68 12.68 6.31 12.68 6.7 12.29L17.3 1.70001C17.3926 1.60848 17.4662 1.49948 17.5164 1.37932C17.5666 1.25916 17.5924 1.13023 17.5924 1.00001C17.5924 0.869783 17.5666 0.740853 17.5164 0.620692C17.4662 0.500532 17.3926 0.391531 17.3 0.300008C17.2085 0.207368 17.0995 0.133816 16.9793 0.0836167C16.8591 0.0334172 16.7302 0.00756836 16.6 0.00756836C16.4698 0.00756836 16.3408 0.0334172 16.2207 0.0836167C16.1005 0.133816 15.9915 0.207368 15.9 0.300008L6 10.2Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tickIcon.8f82cfce6ae4ae52f5a677922d04b8cd.svg";
export { ForwardRef as ReactComponent };